export const combineContexts = (...contexts) =>
  contexts.reduce(
    (AccumulatedContexts, CurrentContext) =>
      ({ children }) => (
        <AccumulatedContexts>
          <CurrentContext>{children}</CurrentContext>
        </AccumulatedContexts>
      ),
    ({ children }) => children
  );
